import {Icon36CoinsStacks2Outline, Icon56CheckCircleOutline} from "@vkontakte/icons";
import {Button, ModalCard} from "@vkontakte/vkui";
import {observer} from "mobx-react-lite";
import React from 'react';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import GameStore from "../../store/game";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {ReferralInviteCta} from "../../components/ReferralInviteCta/ReferralInviteCta";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS
} from "../modalStyles";

// Модальное окно, которые мы показываем после того как игрок выиграл
export const SuccessFinishGameModal = observer(({nav}) => {
    const {width, height} = useWindowSize();
    const routeNavigator = useRouteNavigator();

    const subheader = (
        <div className={"text-center text-gray-700"}>
            <p>Слово: <span className={"font-bold uppercase tracking-widest text-gray-900"}>{GameStore.word}</span></p>
            <p>Попыток: {GameStore.attemptNumber}/{GameStore.attemptHistory.length}</p>
            <div className={"flex flex-row justify-center items-center"}>
                <p>Заработано монет: <span className={"text-brand-success"}>+{GameStore.earnedCoins}</span></p>
                <Icon36CoinsStacks2Outline width={16} height={16} className={"ml-1 text-yellow-500"}/>
            </div>
        </div>
    );

    return (
        <>
            <Confetti
                recycle={false}
                width={width}
                height={height}
            />
            <ModalCard
                nav={nav}
                onClose={() => routeNavigator.hideModal()}
                className={MODAL_CARD_CLASS}
                icon={<Icon56CheckCircleOutline className={"text-brand-success"}/>}
                header={<span className={MODAL_HEADER_CLASS}>Победа!</span>}
                subheader={subheader}
                actions={
                    <div className={"flex flex-col w-full gap-2"}>
                        <Button
                            size="l"
                            mode="secondary"
                            className={MODAL_SECONDARY_BUTTON_CLASS}
                            onClick={() => routeNavigator.hideModal()}
                        >
                            Закрыть
                        </Button>
                    </div>
                }
            >
                <ReferralInviteCta source="game_finished" variant="inline"/>
            </ModalCard>
        </>
    )
});
